import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import NotesErrorState from "@store/Framework/Store/Store/Data/NotesError/NotesErrorState";
import { Draft } from "immer";

const initialState: NotesErrorState = {
    notesError: false,
};

const actions = {
    "Store/Data/Checkout/SetNotesError": (draft: Draft<NotesErrorState>, action: { notesError: boolean }) => {
        draft.notesError = action.notesError;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreNotesErrorActions = Parameters<typeof reducer>[1];
export default reducer;
